var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4L4 4.83333M4 4.83333L1.5 12.3333C2.9771 13.4445 5.02389 13.4445 6.50099 12.3334M4 4.83333L6.50005 12.3333M4 4.83333L9 3.16667M14 4.83333L16.5 4M14 4.83333L11.5 12.3333C12.9771 13.4445 15.0239 13.4445 16.501 12.3334M14 4.83333L16.5 12.3333M14 4.83333L9 3.16667M9 1.5V3.16667M9 16.5V3.16667M9 16.5H6.5M9 16.5H11.5",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.73cab9acf49188242ed833177492c2d9.svg";
export { ForwardRef as ReactComponent };